module.exports = __webpack_public_path__ + "static/media/ArrowLeft.cd4a34d2.svg";